import { combineReducers } from 'redux';

import { reducer as ping } from './pingModule';
import { reducer as whatismyip } from './whatismyipModule';

export default combineReducers({
	ping,
	whatismyip,
});
